import dayjs from 'dayjs';

export const isSameMonth = (dateA: dayjs.Dayjs, dateB: dayjs.Dayjs) => {
  return dateA.isSame(dateB, 'month');
};
